
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instructors/[slug]",
      function () {
        return require("private-next-pages/instructors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instructors/[slug]"])
      });
    }
  